// extracted by mini-css-extract-plugin
export var disabled = "cM_bV";